/**
 * Hostnames eligible for ?token=<manage_token> in recommendation / test links.
 * Keep in sync with supabase/functions/_shared/autoLoginHosts.ts (send-time injection).
 */

export const AUTO_LOGIN_APEX_DOMAINS = [
  'stephansmith.me',
  'lowcodecto.com',
  'picklestacosandtech.com',
] as const;

export const AUTO_LOGIN_EXCLUDED_HOSTS = [
  'book.stephansmith.me',
  'mail.stephansmith.me',
  'cdn.stephansmith.me',
  'engine.lowcodecto.com',
  'cdn.lowcodecto.com',
] as const;

export function isAutoLoginHost(hostname: string): boolean {
  const host = hostname.toLowerCase().trim();
  if (!host) return false;
  if ((AUTO_LOGIN_EXCLUDED_HOSTS as readonly string[]).includes(host)) return false;

  for (const apex of AUTO_LOGIN_APEX_DOMAINS) {
    if (host === apex || host === `www.${apex}` || host.endsWith(`.${apex}`)) {
      return true;
    }
  }
  return false;
}

export function isAutoLoginOrigin(url: string): boolean {
  try {
    return isAutoLoginHost(new URL(url).hostname);
  } catch {
    return false;
  }
}
